// extracted by mini-css-extract-plugin
export default {"navigatorTabs":"styles_navigatorTabs__OXM8U","navigatorTabWrapper":"styles_navigatorTabWrapper__9yJ-3"};